import { Injectable } from '@angular/core';
import {
  HttpRequest,
  HttpHandler,
  HttpEvent,
  HttpInterceptor
} from '@angular/common/http';
import { Observable, throwError } from 'rxjs';
import { Router } from '@angular/router';
import { catchError } from 'rxjs/internal/operators/catchError';
import { SessionStorageService } from 'ngx-webstorage';
import { MyserviceService } from './myservice.service';
import { MessageService } from 'primeng/api';

@Injectable()
export class HttpInterceptorInterceptor implements HttpInterceptor {
  userData: any;
  constructor(public router: Router,public session: SessionStorageService,public service:MyserviceService,private messageService: MessageService) { }
  intercept(request: HttpRequest<unknown>, next: HttpHandler): Observable<HttpEvent<unknown>> {

/*     const currentUser = JSON.parse(sessionStorage.getItem('loginData'));
    console.log('intreceptor', currentUser);
    if (currentUser !== null) {
      const currentUserToken = JSON.parse(sessionStorage.getItem('loginData'))
        .data.token;
      request = request.clone({
        setHeaders: {
          Authorization: `Bearer ${currentUserToken}`,
        },
      });
    }
    console.log('interCeptors', request); */
    this.userData=this.service.getUserData();
     request=request.clone({ headers: request.headers.append('isAll', this.userData.isAllPartnersVisible) });
     request=request.clone({ headers: request.headers.append('isAllSfg', this.userData.isAllSfgPartnersVisible) });    
    return next.handle(request).pipe(catchError(err => {
      if (err.status === 401 || err.status === 403) {
        sessionStorage.clear();
        this.session.clear();
        this.router.navigateByUrl("login");
      }
      else if (err.status === 404) {
        this.messageService.add(
          { severity: 'error', summary: 'Error', detail: `Requested resource is not found` }
        );
      }
      else if (err.status === 500) {
        this.messageService.add(
          { severity: 'error', summary: 'Error', detail: `Something went wrong, please contact admin` }
        );
      }
      const error = (err.error && err.error.message) || err.statusText || 'An unknown error occurred';
      return throwError(error);
    }))
  }
} 
